import { Button, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import useEditHomework from "../../hooks/api/homework/useEditHomework";
import { useCallback } from "react";
import { encode } from "js-base64";
import { cuesToVTT } from "../../utils/vtt";
import useHomeworkState from "../../state/homework.state";
import { Homework } from "../../models/Homework";

type Props = {
  homework: Homework;
};

export default function EditHomeworkButton({ homework }: Props) {
  const { t } = useTranslation();
  const toast = useToast();
  const { mutateAsync: editHomework, isPending: isEditHomeworkPending } =
    useEditHomework(homework.id);
  const {
    subtitles,
    captions,
    categories,
    voiceOvers,
    dubbings,
    audioDescriptions,
  } = useHomeworkState();

  const doEditHomework = useCallback(() => {
    editHomework({
      homework: {
        ...homework,
        subtitleVtt: encode(cuesToVTT(subtitles, categories)),
        captionVtt: encode(cuesToVTT(captions, categories)),
        categories,
        voiceOvers,
        dubbings,
        audioDescriptions,
      },
    }).then(() =>
      toast({
        title: t("homework_page.exercise_uploaded"),
        description: t("homework_page.exercise_uploaded_message"),
        status: "success",
        isClosable: true,
      }),
    );
  }, [
    audioDescriptions,
    captions,
    categories,
    dubbings,
    editHomework,
    homework,
    subtitles,
    t,
    toast,
    voiceOvers,
  ]);

  return (
    <Button
      bg="primary.DEFAULT"
      color="white"
      onClick={doEditHomework}
      isLoading={isEditHomeworkPending}
    >
      {t("common.buttons.save")}
    </Button>
  );
}
